import * as actionTypes from './actionTypes';
import * as actionUrl from '../../config/actionUrl';
import {
    convertObjectToArray
} from '../../util/utility';
import axios from 'axios';
import * as error from '../../config/errorMsg'

export const resetAdminPortalStore = () => {
    return {
        type: actionTypes.RESET_ADMIN_PORTAL_STORE
    }
}

export const loadViomeKitsStart = () => {
    return {
        type: actionTypes.LOAD_VIOME_KITS_START
    }
}

export const loadViomeKitsFail = (errorResponse) => {
    return {
        type: actionTypes.LOAD_VIOME_KITS_FAIL,
        error: errorResponse.debugMessage
    };
}

export const loadViomeKitsSuccess = (productResponse) => {
    let kits = [];
    if(productResponse.message !== error.EMPTY_KITS){
        kits = convertObjectToArray(productResponse.response, ["kitName", "kitLabel"])
    }
    return {
        type: actionTypes.LOAD_VIOME_KITS_SUCCESS,
        kits: kits,
        message: productResponse.message,
        kitList: productResponse.response
    }
}

export const loadViomeKits = () => {
    return dispatch => {
        dispatch(loadViomeKitsStart())
        axios.get(actionUrl.LOAD_VIOME_KITS_URL, {
            headers: {
                'Content-Type': 'application/json'
            },
            mode: "cors",
            withCredentials: true
        }).then(res => {
            dispatch(loadViomeKitsSuccess(res.data.ProductResponse));
        }).catch(error => {
            dispatch(loadViomeKitsFail(error));
        });

    }
}

export const loadViomeTestsStart = () => {
    return {
        type: actionTypes.LOAD_VIOME_TESTS_START
    }
}

export const loadViomeTestsFail = (errorResponse) => {
    return {
        type: actionTypes.LOAD_VIOME_TESTS_FAIL,
        error: errorResponse.debugMessage
    };
}

export const loadViomeTestsSuccess = (productResponse) => {
    let tests = [];
    if(productResponse.message !== error.EMPTY_TESTS){
        tests = convertObjectToArray(productResponse.response, ["testName", "testLabel"]);
    }
    return {
        type: actionTypes.LOAD_VIOME_TESTS_SUCCESS,
        tests: tests,
        message: productResponse.message,
        testList: productResponse.response
    }
}


export const loadViomeTests = () => {
    return dispatch => {
        dispatch(loadViomeTestsStart());
        axios.get(actionUrl.LOAD_VIOME_TESTS_URL, {
            headers: {
                'Content-Type': 'application/json'
            },
            mode: "cors",
            withCredentials: true
        }).then(res => {
            dispatch(loadViomeTestsSuccess(res.data.ProductResponse));
        }).catch(error => {
            dispatch(loadViomeTestsFail(error));
        });

    }
}